export enum SubscriptionTierEnum {
    Basic = 1,
    Business = 2,
    Premium = 3,
    Custom = 4,
    Free = 5,
    Starter = 6,
    Custom_Slider = 7,
    POS_Starter = 8,
    POS_Growth = 9,
    POS_Scale = 10,
    POS_Enterprise = 11,
    Premium_3 = 12,
    Premium_5 = 13,
    Premium_10 = 14,
    Premium_15 = 15,
    Premium_20 = 16
}